<template>
  <!-- 测一测你是哪种购物星球人 -->
  <div v-if="show_body">
    <!-- 引导部分 -->
    <transition name="fade">
      <div v-if="!star_type" class="shopping-star">
        <img class="bg" src="@a/ceping79/page2.png" alt="" />
        <div class="text">
          <p>《双十一购物领袖继任大典》<br />即将开启</p>
          <p>
            现任购物星球最高领袖给潜伏在地<br />球的购物星人发送了一个秘密任务<br />“为保护购物星人利益<br />在双十一让地球人少赚多买。”
          </p>
          <p>活动期间贡献最突出者<br />可当选购物星球的最高领袖。</p>
        </div>
        <!-- btn -->
        <button @click="start" class="ce-btn">测一测</button>
      </div>
    </transition>
    <!-- 答题部分 -->
    <div v-if="star_type" class="shopping-star-question">
      <img class="bg" src="@a/ceping79/que-bg.png" alt="" />
      <!-- title -->
      <img class="title" src="@a/ceping79/que-title.png" alt="" />
      <!-- box -->
      <div class="box">
        <img class="top" src="@a/ceping79/que-top.png" alt="" />
        <img class="bottom" src="@a/ceping79/que-bottom.png" alt="" />
        <!-- <div v-for="(item,index) in list" :key="index"> -->
        <h3 class="que-title">{{ list[list_index].question }}</h3>
        <div
          v-if="otem && otem.split(':')[0]"
          @click="clickOption(otem, index)"
          v-for="(otem, odx) in strToArr(list[list_index].options)"
          :key="odx"
          :class="[
            'option',
            list[list_index]['val']  && list[list_index]['val'] != otem.split(':')[1] ? 'on' : '',
          ]"
        >
          <img
            v-if="list[list_index]['val'] == otem.split(':')[1]"
            class="on"
            src="@a/ceping79/que-on.png"
            alt=""
          />
          <div class="a-z">
            {{ String.fromCharCode("A".charCodeAt(0) + odx) }}
          </div>
          <div class="text">{{ otem.split(":")[0] }}</div>
        </div>
        <!-- </div> -->
      </div>
      <!-- btn -->
      <div class="btn-group">
        <button @click="preQuestion()" v-if="list_index > 0">上一题</button>
        <button :class="[list_index==0?'on':'']" v-if="list.length - 1 > list_index" @click="nextQuestion()">
          下一题
        </button>
        <button v-if="list.length - 1 == list_index" @click="saveQuestion()">
          提交结果
        </button>
      </div>
    </div>
    <!-- 弹窗部分 -->
    <!-- 自己 -->
    <van-popup class="radius" :close-on-click-overlay="false" v-model="kc_show">
      <div class="pop pr text-center">
        <p>你的专属报告已生成</p>
        <p>长按识别关注公众号“立即查看”</p>
        <!-- <img src="../../../assets/cep_ewm.png" /> -->
        <div class="text-center">
          <img class="qr-box" :src="qrcode" alt="" />
        </div>
      </div>
    </van-popup>
    <!-- 未购买 -->
    <van-popup
      class="pub_alert"
      v-model="is_buy"
      :close-on-click-overlay="false"
    >
      <div class="confirm_box">
        <h2>此测评属于最佳工作模式课程，快去购买课程测评吧</h2>
        <div class="btn_group">
          <router-link
            class="confirm"
            :to="{
              path: '/course_details',
              query: {
                bid: 2,
              },
            }"
            >购买最佳工作模式课程</router-link
          >
        </div>
      </div>
    </van-popup>
    <!-- 判断链接是否失效 -->
    <van-popup
      class="pub_alert"
      v-model="failureShow"
      :close-on-click-overlay="false"
    >
      <div class="confirm_box">
        <h2 class="on">{{ failureMsg }}</h2>
      </div>
    </van-popup>

    <!-- 填写个人资料 -->
    <answer-collect :cid="data.cid" :query="$route.query" :extraObj="extraObj" v-if="userInfoBool" @saveuserinfo="saveUserInfo"></answer-collect>
  </div>
</template>

<script>
import { ceping79_index, ceping79_answer, ceping_event, get_extra_info } from "@/api/measurement";
import {
  queryString,
  getStorage,
  setStorage,
  deleteStorage,
} from "@/utils/tools";
import { shareCon } from "@/utils/wxconfig";
import AnswerCollect from "@c/measurement/answer-collect";
import { phoneValidation } from '@/utils/validation'

export default {
  data() {
    return {
      type_obj: {
        evaluation_id: "",
        evaluation_name: "",
        evaluation_id: "",
        nickname: "",
      },
      show_body: false,
      // 当前第几题
      list_index: 0,
      list: [],
      qrcode: "",
      //
      nickname: "",
      kc_show: false,
      // 上一页面路由
      formPath: "",
      failureShow: false,
      interruptShow: false,
      failureMsg: "",
      //
      star_type: false,
      option_list: [1, 2, 3, 4, 5, 6],
      lock:true,

      // 存储答题数据
      extra:{},
      extraObj:{},
      userInfoBool:false,
      queArr:[],
    };
  },
  components: {
    AnswerCollect,
  },
  methods: {
    start() {
        let bool = true;
        get_extra_info().then(data=>{
          for(let i=0;i<Object.keys(this.extraObj).length;i++){
            let item = Object.keys(this.extraObj)[i];
            if(data.extra[item]){
              this.extra[item] = data.extra[item];
            }else{
              bool = false;
            }
          }

          if(bool){
            this.next();
          }else{
            this.userInfoBool = true;
          }
        });
    },
    next() {
        this.star_type = true;
    },
    // 提交个人信息和答题数据
    saveUserInfo(extra){
        if(extra) {
          this.extra = extra;
        }
        
        this.userInfoBool = false;
        this.next();
    },
    // 提交结果
    saveQuestion(){
      let arr = [];
      for(let item of this.list){
        if(!item['val']){
          this.$toast('请先答完所有选题哦~');
          return
        }
        arr.push({
          qid:item.id,
          cid:79,
          score:item['val']
        });
      }

      let obj = {
        answer:arr
      };
      if(this.$route.query.sid){
          obj['sid'] = this.$route.query.sid;
      }
      for(let i=0;i<Object.keys(this.extraObj).length;i++){
        let item = Object.keys(this.extraObj)[i];
        if(!this.extra[item]){
          this.$toast(`${this.extraObj[item]}不能为空！`);
          return
        }else if(!phoneValidation(this.extra.phone)){
          this.$toast('手机号格式不正确！');
          return
        }else{
          obj[item] = this.extra[item];
        }
      }
      
      ceping79_answer(obj).then(data=>{
        if (data.code == 10002) {
          this.$toast(data.msg);
          return
        }
        let q = this.$route.query;
        this.$toast('提交成功!');
        setTimeout(() => {
          // console.log(this.formPath);
          if (this.formPath === '/ceping79_report') {
            this.$router.back();
          } else {
            q['uid'] = data.uid;
            this.$router.push({
              path: '/ceping79_report',
              query: q
            })
          }
        }, 200)
      });
    },
    // 上一题
    preQuestion() {
      if (this.list_index <= 0) {
        return;
      }
      setTimeout(()=>{
        this.list_index--;
      },200)
    },
    // 下一题
    nextQuestion() {
      if (this.list.length - 1 == this.list_index) {
        return;
      }
      if(this.lock){
        this.lock = false;
        setTimeout(()=>{
          this.list_index++;
          this.lock = true;
      },300)
      }
    },
    // 转换选项数据格式
    strToArr(str) {
      if (!str) {
        return [];
      }
      return str.split(";");
    },
    // 点击题目触发
    clickOption(otem, index) {
      this.$set(this.list[this.list_index], "val", otem.split(":")[1]);
      if (this.list.length - 1 > this.list_index) {
        this.nextQuestion();
      }
      
    },
    // 初始化数据
    pullData() {
      //调用加载中
      this.$emit("loadingHandle", true, "拼命加载中...");
      let q = this.$route.query;

      let obj = {
        share_uid: q.share_uid || "",
        channel: q.channel || "",
      };
      ceping79_index().then((data) => {
        if (data.code != 10002) {
          this.data = data;
          this.extraObj = data.extra || {};

          this.type_obj.evaluation_id = data.cid;
          this.type_obj.evaluation_name = data.headtitle;
          this.type_obj.evaluation_user_id = data.uid;
          this.type_obj.nickname = data.nickname;
          this.type_obj.path = this.$route.path;
          shareCon("ceping79", this, this.type_obj);

          ceping_event({ lead_sid: this.$route.query.lead_sid,
            cid: data.cid,
            event: 'ViewIndex',
          }).then(res=>{
            // 页面访问统计
          });
          
          //判断是否是已购买课程并且链接已使用或者失效
          if (data.msg) {
            this.failureMsg = data.msg;
            this.failureShow = true;
          } else {
            //判断是否是已购买课程并且有本地缓存
            if (data.is_buy && window.localStorage.getItem(this.$route.path)) {
              this.interruptShow = true;
            }
            // 设置数据
            this.initCptData(data);
          }
          // 显示
          this.show_body = true;
        } else {
          if (this.formPath === "/ceping79_report") {
            this.$router.back();
          } else {
            this.$router.push({
              path: "/ceping79_report",
              query: this.$route.query,
            });
          }
        }
        //关闭加载中
        this.$emit("loadingHandle", false);
      });
    },
    initCptData(data) {
      this.subscribe = data.subscribe;
      if (!data.need_subscribe) {
        this.subscribe = true;
      }
      this.qrcode = data.qrcode;
      this.list = data.list;
      //
      this.nickname = data.nickname;
      document.title = data.headtitle;
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      //  这里的vm指的就是vue实例，可以用来当做this使用
      vm.formPath = from.path;
    });
  },
  created() {
    this.pullData();
  },
};
</script>

<style lang="scss" scoped>
/* 设置持续时间和动画函数 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity .8s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active, 2.1.8 版本以下 */ {
  opacity: 0;
}
// 引导部分
.shopping-star {
  display: flex;
  padding-top: 270px;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  overflow-x: hidden;
  img.bg {
    position: fixed;
    width: 100%;
    max-width: 750px;
    left: 50%;
    transform: translateX(-50%);
    top: 0;
    z-index: -1;
  }
  .text p {
    font-size: 30px;
    font-weight: 400;
    color: #b2f4ff;
    line-height: 55px;
    margin-bottom: 50px;
    &:last-child {
      margin-bottom: 170px;
    }
  }
  .ce-btn {
    font-size: 38px;
    width: 600px;
    height: 88px;
    line-height: 88px;
    color: #ffffff;
    text-shadow: 0px 4px 4px #009ac9;
    background: linear-gradient(0deg, #b2f4ff 0%, #25cafe 100%);
    border-radius: 20px;
    margin: 0 auto;
    border: none;
    font-weight: bold;
    letter-spacing: 4px;
  }
}
// 答题部分
.shopping-star-question {
  text-align: center;
  overflow-x: hidden;
  img.bg {
    position: fixed;
    width: 100%;
    max-width: 750px;
    height: 100%;
    left: 50%;
    transform: translateX(-50%);
    top: 0;
    z-index: -1;
  }
  .title {
    margin: 100px auto 40px;
    width: 698px;
    height: 114px;
  }
  .box {
    margin: 0 auto;
    width: 690px;
    padding: 55px 30px 30px;
    background: #ffffff;
    box-shadow: 0px 4px 4px 0px rgba(0, 14, 39, 0.31);
    border-radius: 20px;
    position: relative;
    .top {
      position: absolute;
      right: -40px;
      width: 125px;
      top: -40px;
    }
    .bottom {
      height: 143px;
      position: absolute;
      right: -120px;
      bottom: -55px;
    }
    .que-title {
      text-align: left;
      font-size: 36px;
      font-weight: 600;
      color: #333333;
      line-height: 48px;
    }
    .option {
      text-align: left;
      border: 2px solid #a2e0ed;
      border-radius: 20px;
      color: #333333;
      line-height: 36px;
      margin-top: 20px;
      display: flex;
      align-items: center;
      padding: 24px;
      position: relative;
      .on {
        position: absolute;
        top: -14px;
        left: -7px;
        width: 72px;
        height: 66px;
      }
      .a-z {
        font-size: 36px;
        margin-right: 20px;
        font-weight: bold;
      }
      .text {
        font-size: 28px;
      }
      &:first-child {
        margin-top: 40px;
      }
    }
    .option.on {
      opacity: 0.5;
    }
  }
  .btn-group {
    display: flex;
    margin: 70px auto 48px;
    justify-content: center;
    button {
      width: 300px;
      height: 80px;
      line-height: 80px;
      background: linear-gradient(0deg, #b2f4ff 0%, #25cafe 100%);
      border-radius: 20px;
      border: none;
      color: #ffffff;
      font-size: 38px;
      font-weight: bold;
      text-shadow: 0px 4px 4px #009ac9;
      &:first-child {
        margin-right: 30px;
      }
    }
    button.on{
      margin-right: 0;
    }
  }
}
.confirm_box {
  padding: 50px 40px;
  border-radius: 12px;
}

.confirm_box h3 {
  margin: 10px 0;
  color: #999;
  font-size: 26px;
  text-align: center;
}

.confirm_box a.cancel {
  color: #fff;
  background-color: #eb5032;
  line-height: 60px;
  text-align: center;
  font-size: 28px;
  display: block;
  margin: 0 auto;
  margin-top: 40px;
  border-radius: 8px;
}

.grouping .van-cell .van-cell__value input {
  border: 2px solid #ccc;
  border-radius: 12px;
  font-size: 26px;
  color: #333;
}
.save-userinfo {
  position: fixed;
  width: 100%;
  max-width: 750px;
  left: -100%;
  transform: translateX(-50%);
  top: 0;
  height: 100%;
  background-color: #ffffff;
  padding: 150px 60px 100px;
  overflow: auto;
  .u-title {
    font-size: 36px;
    color: #333;
    text-align: center;
    margin-bottom: 80px;
    font-weight: bold;
  }
  .u-input {
    display: flex;
    align-items: center;
    font-size: 30px;
    margin-bottom: 50px;

    label {
      display: block;
      width: 150px;
      text-align: right;
    }
    input {
      line-height: 70px;
      flex: 1;
      border: 2px solid #f57f17;
      border-radius: 15px;
      padding-left: 10px;
      font-size: 26px;
      background-color: #ffffff;
    }
    .interest-label {
      width: 600px;
    }
    .interest-label.on {
      width: 150px;
      text-align: right;
    }
  }
  .u-input:last-child {
    margin-bottom: 200px;
  }
  .u-btn {
    display: block;
    margin: 0 auto;
    width: 100%;
    border-radius: 15px;
    border: none;
    background-color: #f57f17;
    font-size: 32px;
    text-align: center;
    color: #ffffff;
    line-height: 80px;
  }
}
.save-userinfo.on {
  left: 50%;
}
.progress {
  position: fixed;
  height: 8px;
  left: 0;
  top: 0;
  z-index: 3;
  background: red;
  transition: all 0.3s;
}

.pg-num {
  position: fixed;
  padding: 10px;
  top: 10px;
  right: 10px;
  z-index: 4;
  background: red;
  transition: all 0.3s;
  color: #fff;
  border-radius: 30px;
}
.m-error {
  bottom: 60px;
  position: fixed;
  width: 80px;
  line-height: 80px;
  height: 80px;
  text-align: center;
  right: 40px;
  z-index: 4;
  background: #fff;
  transition: all 0.3s;
  color: #f57f17;
  border: 2px solid #f57f17;
  border-radius: 50%;
  box-sizing: border-box;
}
.error-pop {
  background: transparent;
}
.error {
  background-color: #ffffff;
  width: 690px;
  padding: 30px;
  border-radius: 15px;
  h3 {
    font-size: 34px;
    color: #333;
  }
  textarea {
    margin: 40px auto 90px;
    resize: none;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 8px;
    line-height: 39px;
    width: 100%;
    background-color: #f5f5f5;
  }
  .error-footer {
    border-top: 1px solid #d3d3d3;
    display: flex;
    position: absolute;
    bottom: 0;
    width: 100%;
    left: 0;
    line-height: 90px;
    a {
      flex: 1;
      text-align: center;
      font-size: 34px;
      color: #333;
      &:nth-child(1) {
        color: #eb5032;
      }
      &:nth-child(2) {
        color: #666666;
        border-left: 1px solid #d3d3d3;
      }
    }
  }
}

.mt32 {
  margin-top: 32px;
}

.pt32 {
  padding-top: 32px;
}

.pb-public {
  padding: changeRem(0.425) + px;
}

.pop {
  img {
    max-width: 8rem;
  }
}

.radius {
  border-radius: 10px;
}

.pop {
  width: 8rem;
  padding-bottom: 80px;
  p:nth-child(1) {
    padding-top: 50px;
    font-size: 34px;
    line-height: 80px;
    font-weight: bold;
    color: #f57f17;
  }
  p:nth-child(2) {
    color: #333;
    font-size: 30px;
    line-height: 80px;
  }
  img {
    width: 80%;
  }
}

.confirm_box {
  h2 {
    padding: 40px 30px;
  }
  h2.on {
    padding: 60px 30px;
  }
  p {
    margin-bottom: 50px;
    font-size: 26px;
    color: #666;
  }
  .btn_group {
    .confirm {
      color: #999999;
    }
    .cancel {
      color: #eb5032;
    }
  }
}

// 弹出开始测评说明
.answer-sheet {
  transition: all 2s;
  position: fixed;
  z-index: 998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.answer-sheet.on {
  left: -1500px;
}
.save-userinfo {
  position: fixed;
  width: 100%;
  max-width: 750px;
  left: -100%;
  transform: translateX(-50%);
  top: 0;
  height: 100%;
  background-color: #ffffff;
  padding: 150px 60px 100px;
  .u-title {
    font-size: 36px;
    color: #333;
    text-align: center;
    margin-bottom: 80px;
    font-weight: bold;
  }
  .u-input {
    display: flex;
    align-items: center;
    font-size: 30px;
    margin-bottom: 50px;
    label {
      display: block;
      width: 150px;
      text-align: right;
    }
    input {
      line-height: 70px;
      flex: 1;
      border: 2px solid #f57f17;
      border-radius: 15px;
      padding-left: 10px;
      font-size: 26px;
      background-color: #ffffff;
    }
  }
  .u-input.on {
    flex-direction: column;
    label {
      display: block;
      margin-right: auto;
      text-align: left;
    }
    .ra {
      width: 100%;
      line-height: 80px;
      padding-left: 150px;
    }
  }
  .u-btn {
    display: block;
    margin: 0 auto;
    width: 100%;
    border-radius: 15px;
    border: none;
    background-color: #f57f17;
    font-size: 32px;
    text-align: center;
    color: #ffffff;
    line-height: 80px;
  }
}
.save-userinfo.on {
  left: 50%;
}
</style>
<style lang="scss">
.ra .row {
  display: flex;
  .radio {
    margin-left: 30px;
    &:first-child {
      margin-left: 0;
    }
  }
}
</style>